"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var UrlShortenerApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(UrlShortenerApi, _BasicApi);

  /**
   * @constructor
   */
  function UrlShortenerApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        urlShortenerUrl = _ref.urlShortenerUrl,
        accountId = _ref.accountId;
    (0, _classCallCheck2.default)(this, UrlShortenerApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UrlShortenerApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.urlShortenerUrl = urlShortenerUrl;
    _this.accountId = accountId;
    return _this;
  }

  (0, _createClass2.default)(UrlShortenerApi, [{
    key: "createShortUrl",
    value: function () {
      var _createShortUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref2) {
        var _this2 = this;

        var url, _ref2$deepLink, deepLink, _ref2$accountId, accountId, headers;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _ref2.url, _ref2$deepLink = _ref2.deepLink, deepLink = _ref2$deepLink === void 0 ? false : _ref2$deepLink, _ref2$accountId = _ref2.accountId, accountId = _ref2$accountId === void 0 ? this.accountId : _ref2$accountId;
                _context.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context.sent;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this2.urlShortenerUrl, "/acc/").concat(accountId, "/link"), {
                    url: url,
                    deepLink: deepLink
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function createShortUrl(_x) {
        return _createShortUrl.apply(this, arguments);
      }

      return createShortUrl;
    }()
  }, {
    key: "updateShortUrl",
    value: function () {
      var _updateShortUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref3) {
        var _this3 = this;

        var url, shortUrl, deepLink, _ref3$accountId, accountId, headers;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = _ref3.url, shortUrl = _ref3.shortUrl, deepLink = _ref3.deepLink, _ref3$accountId = _ref3.accountId, accountId = _ref3$accountId === void 0 ? this.accountId : _ref3$accountId;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context2.sent;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.put("".concat(_this3.urlShortenerUrl, "/acc/").concat(accountId, "/link"), {
                    url: url,
                    deepLink: deepLink,
                    shortUrl: shortUrl
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateShortUrl(_x2) {
        return _updateShortUrl.apply(this, arguments);
      }

      return updateShortUrl;
    }()
  }, {
    key: "deleteShortUrl",
    value: function () {
      var _deleteShortUrl = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref4) {
        var _this4 = this;

        var shortUrl, _ref4$accountId, accountId, headers;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                shortUrl = _ref4.shortUrl, _ref4$accountId = _ref4.accountId, accountId = _ref4$accountId === void 0 ? this.accountId : _ref4$accountId;
                _context3.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context3.sent;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this4.urlShortenerUrl, "/acc/").concat(accountId, "/link"), {
                    shortUrl: shortUrl
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteShortUrl(_x3) {
        return _deleteShortUrl.apply(this, arguments);
      }

      return deleteShortUrl;
    }()
  }]);
  return UrlShortenerApi;
}(_basic.default);

var _default = UrlShortenerApi;
exports.default = _default;